"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Like = function Like(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M18.2048 12.9927C18.8885 12.309 19.2726 11.3817 19.2726 10.4148C19.2726 9.44782 18.8885 8.52048 18.2048 7.83676C17.521 7.15303 16.5937 6.76892 15.6268 6.76892C14.6598 6.76892 13.7325 7.15303 13.0488 7.83676L13.0492 7.83725L13.0488 7.83763L13.048 7.83676L12.5004 8.38438L12.5 8.38407L12.4997 8.38438L11.9521 7.83676L11.9513 7.83763L11.9509 7.83725L11.9513 7.83676C11.2676 7.153 10.3403 6.76884 9.37335 6.7688C8.4064 6.76876 7.47904 7.15284 6.79528 7.83654C6.11152 8.52024 5.72737 9.44757 5.72733 10.4145C5.72728 11.3815 6.11136 12.3088 6.79507 12.9926L6.79489 12.9927L11.951 18.1487L11.9515 18.1482L12.5 18.6968L13.0482 18.1487L18.2042 12.9927L18.2032 12.9917L18.2034 12.9914L18.2048 12.9927ZM12.5 17.2237L12.4995 17.2242L7.53187 12.2564L7.53205 12.2562C7.05021 11.7668 6.78122 11.1068 6.78363 10.42C6.78605 9.73326 7.05967 9.07522 7.54494 8.58921C8.0302 8.10319 8.68781 7.82855 9.3746 7.82507C10.0614 7.82159 10.7217 8.08956 11.2119 8.57064C11.2188 8.5777 11.226 8.58438 11.2333 8.59107L11.9521 9.30991L11.9524 9.30962L12.5 9.85721L13.0476 9.30962L13.048 9.30991L13.7668 8.59107C13.7741 8.58438 13.7813 8.5777 13.7882 8.57064C14.2754 8.08441 14.9353 7.81087 15.6236 7.80981C16.3119 7.80876 16.9726 8.08028 17.4613 8.56501C17.95 9.04974 18.2268 9.70824 18.2313 10.3965C18.2359 11.0848 17.9677 11.7469 17.4854 12.238C17.4705 12.2515 17.4563 12.2658 17.443 12.2809L12.5 17.2237Z",
    fill: props.foregroundColor
  }));
};

Like.defaultProps = {
  altText: "Like",
  foregroundColor: "#2D5AB4"
};
Like.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Like;
exports.default = _default;